import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getReplacements } from "../../redux/actions/replacementAction";
import ReplacementTable from "./ReplacementTable";
 
const Replacement = () => {
    const history = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
 
    useEffect(() => {
        dispatch(getReplacements(setLoading));
    }, [dispatch]);
 
    const allReplacement = useSelector((state) => state.replacement.allReplacement || []);
 
    const getFilteredData = (data, search) => {
        if (!Array.isArray(data)) return [];
        if (!search.length) return data;
 
        return data.filter(
            (item) => item?.reason?.toLowerCase().includes(search.toLowerCase()) || item?.comments?.toLowerCase().includes(search.toLowerCase()),
        );
    };
 
    const filteredReplacement = getFilteredData(allReplacement, search);
    const processedReplacement = filteredReplacement.map((item) => ({
        ...item,
        time: item.time ? new Date(item.time) : null,
    }));
 
    return (
        <ReplacementTable
            heading="All Replacements"
            allReplacement={processedReplacement}
            loading={loading}
            history={history}
            search={search}
            setSearch={setSearch}
        />
    );
};
 
export default Replacement;